export default {
  install: {
    description:
      'L’application Baobab est maintenant disponible sur iPhone et Android',
    title: 'Installez la nouvelle version',
  },
};
